import { render } from "./PostLoginHeader.vue?vue&type=template&id=2ec593a4&scoped=true"
import script from "./PostLoginHeader.vue?vue&type=script&lang=js"
export * from "./PostLoginHeader.vue?vue&type=script&lang=js"

import "./PostLoginHeader.vue?vue&type=style&index=0&id=2ec593a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec593a4"]])

export default __exports__